import React, { useState, useEffect } from 'react';
import { Transition, Button, Icon } from 'semantic-ui-react';
import { SecaoForm, AvisoForm } from '../../layouts/FormUI';
import * as FormValidator from '../../../utils/formValidator';
import Erro from '../../layouts/mensagens/Erro';
import Pergunta from './Pergunta';
import api from '../../../api';

const EditarVotacaoPerguntas = ({ visible, votacao, condominio, votacaoPossuiVoto, handleItemClick, disabledFields }) => {
  const [perguntas, setPerguntas] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(
    () => {
      if (Object.keys(votacao).length > 0 && visible) {
        setLoading(true);
        loadPerguntas();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [votacao, visible]
  );

  const loadPerguntas = async () => {
    try {
      setPerguntas(await api.pergunta.findForEdit(votacao._id));
      setLoading(false);
    } catch (e) {
      setErrors((e.data && e.data.errors) || {});
    }
  };

  const adicionarPergunta = async () => {
    setLoading(true);
    try {
      const result = await api.pergunta.create({ votacao: { _id: votacao._id, condominio: condominio._id } });
      setPerguntas(p => [...p, result]);
    } catch (e) {
      setErrors((e.data && e.data.errors) || {});
    }
    setLoading(false);
  };

  const updatePergunta = pergunta => setPerguntas(p => p.map(it => it._id === pergunta._id ? pergunta : it));

  const excluirPergunta = async pergunta => {
    setLoading(true);
    try {
      const result = await api.pergunta.findByIdAndRemove(pergunta._id);
      setPerguntas(p => p.filter(it => it._id !== result._id));
    } catch (e) {
      setErrors((e.data && e.data.errors) || {});
    }
    setLoading(false);
  };

  const incompleta = perguntas.some(p => FormValidator.isVazio(p.titulo)) || perguntas.some(p => p.respostas.length === 0);

  return (
    <Transition animation="fade up" duration={{ show: 700, hide: 0 }} visible={visible} transitionOnMount={true}>
      <div>
        {votacaoPossuiVoto && (
          <AvisoForm tipo="atencao" icone="warning sign">
            <b>Esta votação já possui votos.</b> Redobre a atenção ao atualizar os dados.
          </AvisoForm>
        )}
        <SecaoForm
          icone="question"
          titulo={`Perguntas / pautas${perguntas.length ? ` (${perguntas.length})` : ''}`}
          descricao="Cada pergunta tem suas respostas possíveis, que os moradores escolhem ao votar. Você também pode anexar documentos e links."
        >
          {perguntas.length ? (
            perguntas.map((pergunta, i) => (
              <Pergunta
                key={pergunta._id}
                pergunta={pergunta}
                votacao={votacao}
                submitExcluir={excluirPergunta}
                updatePergunta={updatePergunta}
                numeroPergunta={i + 1}
              />
            ))
          ) : (
            <div className="va-pergunta-vazio">
              <Icon name="clipboard list" size="big" />
              <Erro text={errors.votacaoPerguntas} />
              <p>Nenhuma pergunta ainda. Clique em "Adicionar nova pergunta / pauta" para começar.</p>
            </div>
          )}
          {incompleta && (
            <AvisoForm tipo="atencao">Finalize as perguntas / pautas que você começou (título e ao menos uma resposta) antes de adicionar uma nova.</AvisoForm>
          )}
          <Button className="btn-ui-1" onClick={adicionarPergunta} loading={loading} disabled={loading || incompleta} size="large">
            <Icon name="plus" /> Adicionar nova pergunta / pauta
          </Button>
        </SecaoForm>
      </div>
    </Transition>
  );
};

export default EditarVotacaoPerguntas;
